import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: 'bg-white border border-[#E5E7EB] shadow-lg rounded-lg text-[#0C111D] text-sm',
          success: 'bg-[#ECFDF3] border-[#027A48] text-[#027A48] [&>svg]:text-[#027A48]',
          error: 'bg-[#FEF3F2] border-[#B42318] text-[#B42318] [&>svg]:text-[#B42318]',
          warning: 'bg-[#FFFAEB] border-[#F79009] text-[#F79009] [&>svg]:text-[#F79009]',
          info: 'bg-[#EAF3FF] border-[#3662EC] text-[#3662EC] [&>svg]:text-[#3662EC]',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
